import { render, staticRenderFns } from "./WaveView.vue?vue&type=template&id=4edecce2&scoped=true&"
import script from "./WaveView.vue?vue&type=script&lang=js&"
export * from "./WaveView.vue?vue&type=script&lang=js&"
import style0 from "./WaveView.vue?vue&type=style&index=0&id=4edecce2&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4edecce2",
  null
  
)

export default component.exports